import React from 'react';
import { useSelector } from 'react-redux';
import { FormattedMessage } from 'react-intl';
import Modal from 'atoms/Modal';

import StyledMatchEndedModal from './StyledMatchEndedModal';
import Button from 'styled/components/Button';

import { ModalProps } from 'atoms/Modal/ModalTypes';

import { endMatch90, goToExtraTime, goToPauseBeforePenalties } from 'features/match/thunks';
import { modalsSlice } from 'features/modals/modalsSlice';
import { selectMatch } from '../../../features/match/matchSlice';
import { StageType } from '../../../enums/stageType';
import { MatchStatus } from '../../../enums/matchStatus';
import { useAppDispatch } from '../../../hooks/hooks';

const MatchEndedModal: React.FC<ModalProps> = (props) => {
  const dispatch = useAppDispatch();
  const match = useSelector(selectMatch);

  const { stage } = match;

  const _endMatch = () => {
    dispatch(endMatch90({}));
    dispatch(modalsSlice.actions.setMatchEndedModal(false));
  };

  const _goToExtraTime = () => {
    dispatch(goToExtraTime({}));
    dispatch(modalsSlice.actions.setMatchEndedModal(false));
  };

  const _goToPenalties = () => {
    dispatch(goToPauseBeforePenalties({}));
    dispatch(modalsSlice.actions.setMatchEndedModal(false));
  };

  let noOfButtons = 1;
  if ([StageType.CUP, StageType.OPEN, StageType.LEAGUE_WITH_PENALTIES].indexOf(stage.stageTypeId) > -1) {
    noOfButtons++;
  }
  if ([StageType.CUP].indexOf(stage.stageTypeId) > -1) {
    noOfButtons++;
  }

  if (match.matchStatusId === MatchStatus.SECOND_HALF_EXTRA_TIME) {
    noOfButtons--;
  }
  if (match.matchStatusId === MatchStatus.PENALTIES) {
    noOfButtons -= 2;
  }

  return (
    <Modal {...props}>
      <StyledMatchEndedModal noOfButtons={noOfButtons}>
        <br />
        <div className="header">
          <FormattedMessage id="matchEnded.sure" />
        </div>
        <br />
        <br />
        <br />
        <div className="buttons">
          <div className="actions">
            {[StageType.CUP].indexOf(stage.stageTypeId) > -1 &&
              match.matchStatusId !== MatchStatus.SECOND_HALF_EXTRA_TIME &&
              match.matchStatusId !== MatchStatus.PENALTIES && (
                <Button onClick={_goToExtraTime}>
                  <FormattedMessage id="states.extraPeriod" />
                </Button>
              )}
            {match.matchStatusId !== MatchStatus.PENALTIES &&
              [StageType.CUP, StageType.OPEN, StageType.LEAGUE_WITH_PENALTIES].indexOf(stage.stageTypeId) > -1 && (
                <Button onClick={_goToPenalties}>
                  <FormattedMessage id="states.penalty" />
                </Button>
              )}
            <Button onClick={_endMatch}>
              <FormattedMessage id="states.matchEnded" />
            </Button>
          </div>
        </div>
      </StyledMatchEndedModal>
    </Modal>
  );
};

export default MatchEndedModal;
